let noLoader = false

document.onreadystatechange = function () {
  if (document.readyState === "complete") {
    $(".page-loader").removeClass("active")
  }
}
$(window).bind("beforeunload", function (e) {
  if (!noLoader) {
    $(".page-loader").addClass("active")
  }
})

$(document).on("click", "a", function () {
  if ($(this).hasClass("no-loader")) {
    noLoader = true
  } else {
    noLoader = false
  }
})
